var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{attrs:{"type":"flex"}},[_c('Col',{attrs:{"span":"20"}},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('Col',{attrs:{"span":"4"}},[_c('Row',{attrs:{"type":"flex","align":"middle","justify":"end"}},[_c('Icon',{attrs:{"type":"more"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6535412c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardHeader.vue
// module id = swmp
// module chunks = 1